import React, {useEffect, useState} from "react";
import clsx from 'clsx';
 
import logo from '../../../assets/img/logo.svg';
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Button from "@material-ui/core/Button";
import TempPhoto from '../../../assets/img/tempPhoto.svg'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import URLS from '../../../config/navigation'
import MENU_LINKS from '../../../config/menuLinks'
import { useHistory ,useLocation } from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {selectProfileInfo} from "../../../store/selectors/Profile";
import {logout} from "../../../store/entities/Auth/Auth.actions";

const links = [
  {
    url: URLS.PROFILE.DATA,
    name: 'My Profile'
  },
  {
    url: URLS.PROFILE.PAYMENTS,
    name: 'Payments'
  }
];

const TopBar = () => {
  
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [curLink, setCurLink] = useState(null);
  const profileInfo = useSelector(selectProfileInfo);

  useEffect(() => {
    setCurLink(location.pathname);
  }, [location])

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (url) => {
    url && history.push(url)
    setAnchorEl(null);
  };

  return (
    <div className={clsx("flexContainer", "topBarContainer")}>
      <div className={clsx("flexContainer", "topbarWrapper")}>
        <div className={"aroundContainer"}>
          <img src={logo} alt="TechOn" />
        </div>
        <div className={clsx("flexContainer", "linkContainer")}>
          <div className={"linkWrapper"}>
            {
              links.map((link, index) => {
                return (
                  <span
                    key={index}
                    className={
                      link.url === curLink ?
                        clsx("link", "topBarLinkActive")
                        : clsx("link", "topBarLink")}
                    onClick={() => history.push(link.url)}
                  >
                    {link.name}
                  </span>
                )
              })
            }
          </div>
        </div>
        <div className={"aroundContainer"}>
          <div className={"menuContainer"}>
            { profileInfo.avatar && (<img className={"profileImg"} src={profileInfo.avatar} alt="User photo"/>)}
            <Button className={"menuBtn"} aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
              <ArrowForwardIosIcon className={"arrowDown"} />
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={() => handleClose()}
            >
              {
                MENU_LINKS.map(
                  (link, index) => (
                    <MenuItem
                      className="menu-item BODY_MEDIUM"
                      key={index}
                      onClick={() => handleClose(link.url)}
                    >
                      {link.name}
                    </MenuItem>
                  ))
              }
              <MenuItem
                className="menu-item BODY_MEDIUM"
                onClick={() => dispatch(logout(() => history.push(URLS.AUTH.SIGNIN)))}
              >
                Logout
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopBar;
